import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import {
	READY_TO_POST_MODAL__BODY_TEXT_TITLE,
	READY_TO_POST_MODAL__CANCEL,
	READY_TO_POST_MODAL__SUBMIT,
	READY_TO_POST_MODAL__TITLE,
} from '../data/constants';

interface MarkAsReadyPaymentModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

const MarkAsReadyPaymentModal = (props: MarkAsReadyPaymentModalProps) => {
	const { open, onClose, onConfirm } = props;
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>{READY_TO_POST_MODAL__TITLE}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{READY_TO_POST_MODAL__BODY_TEXT_TITLE}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color='neutralButton'>
					{READY_TO_POST_MODAL__CANCEL}
				</Button>
				<Button onClick={onConfirm} variant='contained' color='primary'>
					{READY_TO_POST_MODAL__SUBMIT}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default MarkAsReadyPaymentModal;
